import { Button, Container, Paper, Stack, Typography, TextField } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import { useState, useRef } from 'react';
import { toast } from '../../../../../utils';
import axios from 'axios';
import { BASE_URL } from '../../../../../utils';
import { useNavigate } from 'react-router-dom';

export const StateCityImportData = () => {
  const methods = useForm(); // No resolver needed if no validation
  const [file, setFile] = useState(null);
  const fileInputRef = useRef(null); // Reference for file input
  const navigate = useNavigate();

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleCancel = () => {
    setFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = ''; // Reset file input value
    }
  };

  const formSubmitHandler = async (data) => {
    if (!file) {
      toast('Please select a file first.', { variant: 'warning' });
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await axios.post(`${BASE_URL}/city/addBulk`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      if (response.status === 200) {
        toast('State City added successfully', { variant: 'success' });
        setFile(null);
        if (fileInputRef.current) {
          fileInputRef.current.value = ''; // Reset file input value after successful submission
        }
      } else {
        toast('Failed to upload file', { variant: 'error' });
      }
    } catch (error) {
      console.error('Error while uploading file', error);
      toast('Internal Server Error', { variant: 'error' });
    }
  };

  return (
    <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
      <Container
        sx={{
          mt: 2,
          p: 0.2,
          border: '1px solid',
          borderColor: 'grey.300',
          borderRadius: 1,
          width: '100%',
          maxWidth: 'none',
          minWidth: '100%',
          boxSizing: 'border-box'
        }}
      >
        <FormProvider {...methods}>
          <Stack
            direction="row"
            spacing={2}
            justifyContent="space-between"
            alignItems="center"
            sx={{ pb: 0.5, mb: 3, borderBottom: '1px solid', borderColor: 'grey.300' }}
          >
            <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
              State City Import Data
            </Typography>

            <a href="/Excle_Templets/sponsor_demo_template.xlsx" download>
              <Button variant="contained" color="success">
                Excel Format
              </Button>
            </a>
          </Stack>
          <Stack spacing={2} component="form" onSubmit={methods.handleSubmit(formSubmitHandler)}>
            <Stack direction="row" spacing={2} alignItems="center">
              <Typography sx={{ flex: 0.25, fontSize: '1.4rem', fontWeight: 700 }}>Select Excel File</Typography>
              <TextField
                name="file"
                type="file"
                inputRef={fileInputRef} // Attach reference to file input
                sx={{ flex: 1 }}
                inputProps={{ sx: { fontSize: '1.2rem' } }}
                onChange={handleFileChange}
                fullWidth
              />
            </Stack>

            {/* Note below the file input */}
            <Typography variant="body5" color="error">
              Note: Please upload an Excel file (.xlsx) with the correct format. You can download the template from the
              button above.
            </Typography>

            <Stack direction="row" spacing={2} alignItems="center">
              <Button variant="contained" color="primary" type="submit" disabled={!file}>
                Submit
              </Button>
              <Button
                variant="outlined"
                color="error"
                onClick={handleCancel} // Call the cancel handler
              >
                Cancel
              </Button>
            </Stack>
          </Stack>
        </FormProvider>
      </Container>
    </Paper>
  );
};
